import { Attribute, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from "@angular/core";

@Component({
    selector: 'cs-fab',
    templateUrl: 'cs-fab.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsFabComponent {

  @Input() icon: string;
  @ViewChild('fabList') fabList: ElementRef;

  activated: boolean = false;

  constructor(
    @Attribute('bottom') public bottom: boolean,
    @Attribute('right') public right: boolean,
    @Attribute('left') public left: boolean,
    @Attribute('top') public top: boolean,
    public elementRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) { }

  handleActiveCloseButtonClick(ev?: Event) {
    void ev;

    this.activated = !this.activated;
    this.cdr.markForCheck();

    let element = this.elementRef.nativeElement as HTMLElement;
    const fabList = this.fabList.nativeElement as HTMLElement;
    if (this.activated && fabList.children.length > 0) {
      element.classList.add('activated');
      for (let i = 0; i < fabList.children.length; ++i) {
        const fab = fabList.children[i] as HTMLElement;
        if (this.bottom !== null) {
          fab.style.transitionDelay = `${fabList.children.length - 1 - i * 50}ms`;
        } else {
          fab.style.transitionDelay = `${i * 50}ms`;
        }
      }
    } else {
      element.classList.remove('activated');
      for (let i = 0; i < fabList.children.length; ++i) {
        const fab = fabList.children[i] as HTMLElement;
        if (this.bottom !== null) {
          fab.style.transitionDelay = `${i * 50}ms`;
        } else {
          fab.style.transitionDelay = `${fabList.children.length - 1 - i * 50}ms`;
        }
      }
    }
  }

  public close() {
    this.activated = false;
    this.cdr.markForCheck();

    let element = this.elementRef.nativeElement as HTMLElement;

    element.classList.remove('activated');
    const fabList = this.fabList.nativeElement as HTMLElement;
    for (let i = 0; i < fabList.children.length; ++i) {
      const fab = fabList.children[i] as HTMLElement;
      if (this.bottom !== null) {
        fab.style.transitionDelay = `${i * 50}ms`;
      } else {
        fab.style.transitionDelay = `${fabList.children.length - 1 - i * 50}ms`;
      }
    }
  }
}